import { Routes, Route, NavLink } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AuthGuard from './components/AuthGuard';
import MigrationDialog from './components/MigrationDialog';
import Home from './pages/Home';
import Lv1Page from './pages/Lv1';
import Lv2Page from './pages/Lv2';
import Lv3Page from './pages/Lv3';
import Settings from './pages/Settings';
import History from './pages/History';
import FamilyPage from './pages/Family';
import JoinPage from './pages/Join';

function HeaderNav() {
  const { user, family } = useAuth();
  return (
    <header className="header">
      <h1>
        <span role="img" aria-label="speaker">🔊</span> 子供タスク 音声アシスタント
      </h1>
      <nav className="nav-links">
        <NavLink to="/" end>ホーム</NavLink>
        <NavLink to="/history">履歴</NavLink>
        <NavLink to="/family">家族</NavLink>
        <NavLink to="/settings">設定</NavLink>
        {user && family && (
          <span className="muted" style={{ fontSize: '0.75rem' }}>
            👤 {user.email}
          </span>
        )}
      </nav>
    </header>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <div className="app">
        <HeaderNav />
        <Routes>
          <Route path="/join" element={<JoinPage />} />
          <Route
            path="/"
            element={
              <AuthGuard>
                <MigrationDialog />
                <Home />
              </AuthGuard>
            }
          />
          <Route path="/lv1" element={<AuthGuard><Lv1Page /></AuthGuard>} />
          <Route path="/lv2" element={<AuthGuard><Lv2Page /></AuthGuard>} />
          <Route path="/lv3" element={<AuthGuard><Lv3Page /></AuthGuard>} />
          <Route path="/settings" element={<AuthGuard><Settings /></AuthGuard>} />
          <Route path="/history" element={<AuthGuard><History /></AuthGuard>} />
          <Route path="/family" element={<AuthGuard><FamilyPage /></AuthGuard>} />
        </Routes>
      </div>
    </AuthProvider>
  );
}
